<style>
	 @import '@/assets/css/custom.css';
</style>


<template>
    <div>
        <Breadcrumbs main="Brand" title="Brands" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list page-subtitle">
								<div class="row">
									<div class="col-md-10 d-flex">
										<span style="font-size: 20px; font-weight: bolder;">Manage Brands</span>
									</div>
									<div class="col-md-2">
										<!-- <router-link :to="{ name: 'users.adduser' }" class="btn btn-primary">Add User</router-link> -->
										<!-- <div class="btn btn-primary">Add Brand</div> -->
										<button class="btn btn-primary" type="button" data-original-title="test" @click="openModal">Add Brand</button>
										<!-- <button v-b-modal.brand-modal class="primary">Add Brand</button> -->
									</div>								
								</div>
							</div>

							<div class="col-md-12 project-list filter-sort">
									<div class="row">
										<div class="col-md-9 d-flex">
											<label class="d-flex listing-length"><span>Show</span>
												<select class="form-select" v-model="listing_length" @change="fetchBrands()">
													<option value="5">5</option>
													<option value="10">10</option>
													<option value="20">20</option>
												</select>
												<span>entries</span>
											</label>
										</div>
										<div class="col-md-3">
											<input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchBrands()"/>
										</div>
									</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr>
											<th>Brand logo</th>
											<th>Brand name</th>
											<th>Brand status</th>
											<th>Options</th>
										</tr>
									</thead>
									<tbody v-if="Boolean(brands.length)">
										<tr v-for="brand in brands" :key="brand.id">
											<td>
												<img :src="$image_url + brand.brand_image" alt="Image" class="img-fluid avatar-60 rounded-small"/>
											</td>
											<td>
												{{ brand.brand_name }}
											</td>
											<td>
												<label v-if="brand.brand_status == 1">Active</label>
												<label v-else>Blocked</label>
											</td>
											<td>
												<a class="btn btn-primary mt-2 me-1 btn-sm" @click="editBrand(brand)">Edit</a>
												<a class="btn btn-danger mt-2 me-1 btn-sm" @click="deactivateBrand(brand)" v-if="brand.brand_status == 1">Deactivate</a>
												<a class="btn btn-success mt-2 me-1 btn-sm" @click="activateBrand(brand)" v-else>Activate</a>
											</td>
										</tr>
									</tbody>
									<tbody v-else>
										<tr>
											<td colspan="7" class="text-center">No data</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<nav aria-label="Page navigation" class="mt-2">
								<ul class="pagination">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
										<a class="page-link" href="#" @click.prevent="fetchBrands(page.url + '&limit=' + listing_length + '&keyword=' + keyword)" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav>
							<!----pagination ends --->
						</div>
							
					</div>
				</div>
			</div>
		</div>	

		<DynamicModal title="Add Brand">
			<template #body>
				<form @submit.prevent="addBrand" enctype="multipart/form-data">
					<div class="col-md-12 form-group">
						<label class="control-label">Brand Name <span class="required">*</span></label>
						<input class="form-control" type="text" placeholder="" v-model="brand.brand_name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }"/>
						<div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
							<p class="mb-0">{{ val }}</p>
						</div>
					</div>

					<div class="col-md-12 form-group mt-2">
						<label class="control-label">Brand Image <span class="required">*</span> <span>[Allowed Formats: jpg, jpeg, png]</span></label>
						<div v-if="edit" class="form-group">
							<img v-bind:src="$image_url + brand.brand_image" alt="Image not found" style="width:100px;" />
						</div>

						<input type="file" id="fileinput" @change="setFile" accept="image/*" class="form-control image-class" v-bind:class="{ 'is-invalid': Boolean(errors.image) }" />
						<div style="" v-if="edit">
							Leave this field empty if you don't want to change the image
						</div>
						<div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback">
							<p class="mb-0">{{ val }}</p>
						</div>
						<img class="image-preview" v-bind:src="preview_image">
					</div>

					<div class="col-md-12 form-group">
						<button type="submit" class="btn btn-primary me-3" >{{ button_title }}</button>
						<button class="btn btn-light" @click="closeModal()">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>

	</div>
</template>

<script>

import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
	let dynamicmodal;

	export default {
		components: {
			DynamicModal
		},
		setup(){
			onMounted(() => {
				dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
			})

			const showModal = () => {
				dynamicmodal.show();
			}

			const hideModal = () => {
				dynamicmodal.hide();
			}

			return {
				showModal, hideModal
			}
		},

		data() {
			return {
				brands: [],
				types: [],
				brand: {
					id: null,
					brand_name: '',
				},
				image: '',
				preview_image: null,
				modal_title: "Add Brand",
				button_title: "Add",
				pagination: {},
				edit: false,
				brand_status: {
					id: "",
					status: "",
				},
				keyword: "",
				showsearch: false,
				listing_length: 10,
				// token: "",
				token : "",
				errors: {},
				activate: false,
         		deactivate: false,

         		active_page_url: null,
			};
		},
		mounted() {	
		},

		created() {
			this.fetchBrands();
		},

		methods: {
			fetchBrands(page_url = null) {
				let url = "/api/admin/brands?limit=" + this.listing_length + "&keyword=" + this.keyword;
				page_url = page_url || url;

				this.active_page_url = page_url;   

				this.getToken();
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						this.brands = responseData.data;
						this.pagination = responseData.links;
						console.log(this.brands);
					})
					.catch((err) => console.log(err));
			},

			openModal() {
				this.showModal();
			},

			closeModal() {
				this.hideModal();
			},

			getToken() {
                if (localStorage.getItem('slo_admin')) {
                    var slo_admin =  JSON.parse(localStorage.getItem('slo_admin')); 
                    
                    if(slo_admin.token) {

                        this.token = slo_admin.token;
                        this.user = slo_admin;

                    } else {
                        this.$swal("", "Failed to fetch token, please login again", "error");
                        this.$router.push({ name: "Login" });
                    }

                } else {
                    this.$swal("", "Session expired, please login again", "error");
                    this.$router.push({ name: "Login" });
                }
            },

			setFile(e) {
				this.image = e.target.files[0];
				this.preview_image = URL.createObjectURL(this.image);
			},

			addBrand() {
				this.getToken();
				let formData = new FormData();
				formData.append("name", this.brand.brand_name);
				formData.append("image", this.image);
				const config = {
					headers: {
						"content-type": "multipart/form-data",
						Authorization: "Bearer " + this.token,
					},
				};
				let url;
				if (!this.edit) {
					url = "/api/admin/brands/add";
					this.active_page_url = null;
				} else {
					url = "/api/admin/brands/edit";
					formData.append("brand_id", this.brand.id);
				}
				this.$axios
					.post(url, formData, config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message, "success");
						} else {
							this.$swal("", response.data.message, "error");
						}
						this.clearForm();
						this.closeModal();
						this.fetchBrands(this.active_page_url);
					})
					.catch((error) => {
						console.log(error.response.data);

						if (error.response) {
							if (error.response.data.message) {
								this.errors = error.response.data.message;
								this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					});
			},

			editBrand(brand) {
				this.edit = true;
				this.brand.id = brand.id;
				this.brand.brand_name = brand.brand_name;
				this.brand.brand_image = brand.brand_image;
				this.errors = {};
				this.modal_title = "Edit Brand";
				this.button_title = "Update";
				this.showModal();
			},

			clearForm() {
				this.edit = false;
				this.brand.id = null;
				this.brand.brand_name = "";
				this.brand.brand_image = "";
				this.image = null;
				this.preview_image = null;
				this.modal_title = "Add Brand";
				this.button_title = "Add";
				this.errors = {};
				document.getElementById('fileinput').value = '';
			},
			activateBrand(brand) {
				this.activate = false;
				this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to activate this brand?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
						this.brand_status.id = brand.id;
						this.brand_status.status = "1";
						this.updateBrandStatus();
					}
					
				});
			},
			deactivateBrand(brand) {
				this.deactivate = false;
				this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to deactivate this user?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
						this.brand_status.id = brand.id;
						this.brand_status.status = "0";
						this.updateBrandStatus();
					}
				});
			},
			updateBrandStatus() {
				const config = {
					headers: {
						Authorization: "Bearer " + this.token,
					},
				};
				this.$axios
					.get("/api/admin/brands/status?brand_id=" + this.brand_status.id + "&status=" + this.brand_status.status, config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message, "success");
						} else {
							this.$swal("", response.data.message, "error");
						}
						this.fetchBrands(this.active_page_url);
					})
					.catch((error) => {
						if (error.response) {
							if (error.response.data.message) {
								this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					});
			},
		},
	};
</script>